(() => {
  const ROOT_SELECTOR = '[data-paidy-product-widget]';
  const CART_ROOT_SELECTOR = '[data-paidy-cart-widget]';
  const WIDGET_SELECTOR = '._paidy-promotional-messaging';
  const VARIANT_INPUT_SELECTOR = 'form[action*="/cart/add"] [name="id"]';
  const VARIANT_CONTROL_SELECTOR = '[name="id"], [name^="options["]';
  const MINIMUM_AMOUNT = 3000;
  const variantPriceMaps = new WeakMap();

  function getPriceMap(root) {
    if (variantPriceMaps.has(root)) return variantPriceMaps.get(root);

    const data = root.querySelector('[data-paidy-variant-prices]');
    let prices = {};

    try {
      prices = JSON.parse(data?.textContent || '{}');
    } catch (error) {
      prices = {};
    }

    variantPriceMaps.set(root, prices);
    return prices;
  }

  function getVariantId(product, event) {
    const detail = event?.detail;
    const eventVariant = detail?.variant || detail?.selectedVariant;
    const eventVariantId = eventVariant?.id || detail?.variantId;

    if (eventVariantId) return String(eventVariantId);

    const eventTarget = event?.target;
    if (eventTarget?.matches?.('[name="id"]') && eventTarget.value) {
      return String(eventTarget.value);
    }

    const variantInput = product.querySelector(VARIANT_INPUT_SELECTOR);
    return variantInput?.value ? String(variantInput.value) : '';
  }

  function refreshWidget(product, root, event) {
    const widget = root.querySelector(WIDGET_SELECTOR);
    if (!widget) return;

    const variantId = getVariantId(product, event);
    const variant = getPriceMap(root)[variantId];
    const amount = Number(variant?.amount);
    if (!Number.isFinite(amount)) return;

    const wasHidden = root.hidden;
    const isEligible = variant.available && amount >= MINIMUM_AMOUNT;
    const nextAmount = String(amount);
    const amountChanged = widget.dataset.amount !== nextAmount;

    root.hidden = !isEligible;
    root.classList.toggle('is-eligible', isEligible);

    if (amountChanged) {
      widget.dataset.amount = nextAmount;
    }

    if ((amountChanged || wasHidden !== root.hidden) && typeof window._paidy === 'function') {
      window._paidy('pm:refresh');
    }
  }

  function refreshFromEvent(event) {
    const product = event.target?.closest?.('.product') || document.querySelector('.product');
    const root = product?.querySelector(ROOT_SELECTOR);
    if (!product || !root) return;

    requestAnimationFrame(() => refreshWidget(product, root, event));
  }

  function refreshCartWidget(cart) {
    const root = document.querySelector(CART_ROOT_SELECTOR);
    const widget = root?.querySelector(WIDGET_SELECTOR);
    if (!root || !widget || !cart) return;

    const amount = Number(cart.total_price) / 100;
    const itemCount = Number(cart.item_count);
    if (!Number.isFinite(amount) || !Number.isFinite(itemCount)) return;

    const wasHidden = root.hidden;
    const isEligible = itemCount > 0 && amount >= MINIMUM_AMOUNT;
    const nextAmount = String(amount);
    const amountChanged = widget.dataset.amount !== nextAmount;

    root.hidden = !isEligible;
    root.classList.toggle('is-eligible', isEligible);

    if (amountChanged) {
      widget.dataset.amount = nextAmount;
    }

    if ((amountChanged || wasHidden !== root.hidden) && typeof window._paidy === 'function') {
      window._paidy('pm:refresh');
    }
  }

  document.addEventListener('change', (event) => {
    if (!event.target?.matches?.(VARIANT_CONTROL_SELECTOR)) return;
    refreshFromEvent(event);
  });

  ['variant:change', 'variant-change', 'product:variant-change'].forEach((eventName) => {
    document.addEventListener(eventName, refreshFromEvent);
  });

  document.addEventListener('roi:cart:changed', (event) => {
    refreshCartWidget(event.detail?.cart);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const product = event.target?.querySelector?.('.product');
    const root = product?.querySelector(ROOT_SELECTOR);
    if (product && root) {
      variantPriceMaps.delete(root);
      refreshWidget(product, root);

      if (typeof window._paidy === 'function') {
        window._paidy('pm:refresh');
      }
    }

    const cartRoot = event.target?.querySelector?.(CART_ROOT_SELECTOR);
    if (cartRoot && typeof window._paidy === 'function') {
      window._paidy('pm:refresh');
    }
  });
})();
